import React from 'react';
import { IProductDescription } from '../../../ts/models/product/IProductDescription';
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import classnames from 'classnames';

import "./discussion-summary.scss";
import ValueUtils from '../../../ts/utils/ValueUtils';
import { IProductComment } from '../../models/IProductComment';
import ProductCover from '../../../ts/components/common/productCover/ProductCover';
import { ImageDisplayType } from '../../../ts/components/common/PlaceholderImage';
import Avatar from '../../../social/components/common/avatar/Avatar';
import { User } from '../../../social/store/models';

export interface IProps {
    store: ManningOnlineStore;
    product: IProductDescription;
}
export interface IState {}

const renderTopicForumLink = false;

export class DiscussionSummary extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    
    constructor(props: IProps) {
        super(props);

        this.handleDiscussionSummaryUpdated = this.handleDiscussionSummaryUpdated.bind(this);
    }

    public render(){
        const store = this.props.store;
        const discussionSummary = store.getDiscussionSummary(this.props.product.manningId);
        if(discussionSummary == null) { return null; }

        const isDummy = discussionSummary.isDummy;
        const comments = discussionSummary.comments;

        if(!isDummy && (comments == null || comments.length == 0)) { return null; }
        const todaysCommentsCount = this.getTodaysCommentsCount(comments);
        
        return <div className="discussion-summary-root">
                    <div className="discussion-summary-header">
                        <div className="discussions-summary-header-left">
                            <div>
                                <strong>book comments:</strong>
                                <select>
                                    <option>latest</option>
                                    <option>votes</option>
                                </select>
                            </div>
                            <div className="discussion-summary-overview-container">
                                { isDummy && <div className="loader-text-line"></div> }
                                { !isDummy && 
                                <span>
                                    {comments.length} comment{comments.length > 1 ? "s" : ""}
                                    {todaysCommentsCount > 0 ? <> {todaysCommentsCount} today</> : null}
                                </span> }
                            </div>
                        </div>
                        { renderTopicForumLink ?
                            <div className="discussions-summary-header-right">
                                {!isDummy 
                                && <a href={discussionSummary.topicForumLink}>
                                        visit forum: <strong>{discussionSummary.topicForum}</strong>
                                </a> 
                                }
                                <img width="59" height="46" src="https://lx-common-resources.s3.us-west-2.amazonaws.com/assets/discussions.svg" alt="discussions icon"/>
                            </div> 
                        : null }
                    </div>
                    <div className="discussions-summary-comments-container">
                        { isDummy && this.renderDummyComments()}
                        { !isDummy && this.renderComments(comments)}
                    </div>
               </div>
    }

    private renderDummyComments(){
        return [0,-1].map((it) => {
            return <div className="discussion-summary-comment-container" key={it}>
                        <div className="discussion-summary-cover-container">
                            { this.renderCover() }
                        </div>
                        <div className="discussion-summary-comment-info-container">
                            <div className="discussion-summary-comment-title">
                                <div className="loader-text-line"></div>
                            </div>
                            <div className="discussion-summary-comment-body">
                                <div className="loader-text-line"></div>
                                <div className="loader-text-line"></div>
                            </div>
                        </div>
                   </div>
        });
    }

    /*sync with render dummy comments if changes are made! */
    private renderComments(comments: IProductComment[]){
        return comments.map(comment => 
            <div className="discussion-summary-comment-container" key={comment.id}>
                <div className="discussion-summary-cover-container">
                    { this.renderCover() }
                    { comment.avatarUrl && <Avatar user={new User("-1", comment.displayName || (comment.userFistName), comment.avatarUrl)}/>}
                </div>
                <div className="discussion-summary-comment-info-container">
                    <div className="discussion-summary-comment-title" dangerouslySetInnerHTML={{__html: comment.title}}></div>
                    <div className="discussion-summary-comment-body" dangerouslySetInnerHTML={{__html: comment.text}}></div>
                </div>
            </div>
        );
    }

    private renderCover(){
        const productDescription = this.props.product;
        return <ProductCover placeholderImage = {productDescription.isWideCover ? this.props.store.wideCoverPlaceholder : this.props.store.coverPlaceholder}
                             imageDisplayType = {ImageDisplayType.Image}
                             fullImage = {productDescription.coverPath}
                             height={67}
                             width={54}
                             alt={(productDescription.title || "").indexOf("<") >= 0 ? "" : productDescription.title}
                             placeholderOnlyOnFail={false}
                             isLiveaudio={productDescription.isLiveaudio}/>
    }
    
    private getTodaysCommentsCount(comments: IProductComment[]): number {
        const now = new Date();
        return comments.map(it => ValueUtils.getDateFromString(it.dateCreated)).filter(it => now.getTime() - it.getTime() < 24*60*60*1000).length;
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
        this.props.store.onDiscussionSummaryUpdated(this.handleDiscussionSummaryUpdated);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
        this.props.store.offDiscussionSummaryUpdated(this.handleDiscussionSummaryUpdated);
    }

    private handleDiscussionSummaryUpdated(productId: number){
        this.hasBeenMounted && this.props.product != null && this.props.product.manningId == productId && this.forceUpdate();
    }
}